import { UitkIcon } from "uitk-react-icons";
import { decorateEditorialHtml } from "components/flexComponents/Content/ContentUtilities";
import * as React from "react";

/**
 * Editorial item for a items with contentPurpose: Confidence message (and Highlights apparently)
 */
export const ConfidenceEditorialItem = ({
  id,
  text,
  uitkIconName,
}: {
  id: string;
  text?: string;
  uitkIconName?: string;
}) => {
  const confidenceUitkIconName = uitkIconName || "done";

  return (
    <div className="confidenceMessageItem uitk-type-paragraph-300" data-testid="confidenceMsg" data-fm-content={id}>
      <UitkIcon
        className={`confidenceMessageIcon ${confidenceUitkIconName}`}
        name={confidenceUitkIconName}
        data-testid="confidenceIcon"
      />
      <span dangerouslySetInnerHTML={decorateEditorialHtml(text)} />
    </div>
  );
};
